export interface Market {
  value: string;
  name: string;
}

export enum BusinessProfileTab {
  Primary,
  Hours,
  Social,
  Descriptions,
  Images,
  Professional,
  Attributes,
  CustomFields,
  Administration,
}

export enum HiddenField {
  Markets,
  Sales,
  SocialFourSquare,
  CustomerIdentifier,
  Map,
}

export interface LightboxData {
  index: number;
  imageUrls: string[];
}
